/* eslint-disable react-hooks/exhaustive-deps */
import { CircularProgress, Theme, useMediaQuery } from '@material-ui/core';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import ReplayIcon from '@material-ui/icons/Replay';
import { getFromLS, getRestartedResultId, StatusItemGame } from '@orientaction/utils';
import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { apiServiceNative } from '../../../../utils/fetchNative';
import { RedesignLayout } from '../../shared';
import RedesignImage from '../../shared/components/RedesignImage';
import { useSeriousGameViewStyles } from './index.styles';

type GameDetails = {
  id: number;
  title: string;
  couverture: string;
  status?: string;
  pages: unknown[];
};

const RedesignSeriousGameView = () => {
  const classes = useSeriousGameViewStyles();
  const token = getFromLS('userToken') || '';
  const isDisconnected = !token;
  const history = useHistory();
  const { id, idResult }: { id: string; idResult?: string } = useParams();
  const isXS = useMediaQuery((theme: Theme) => theme.breakpoints.down('xs'));

  const [game, setGame] = useState<GameDetails | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id, idResult]);

  useEffect(() => {
    const fetchGameDetails = async () => {
      setLoading(true);

      try {
        const response: GameDetails = await apiServiceNative.get(`/api/details-game/${id}`);

        if (response) {
          setGame(response);
        } else {
          console.error('Invalid response structure:', response);
        }
      } catch (error) {
        console.error('Error fetching game details:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchGameDetails();
  }, [id]);

  const goBackResource = () => {
    if (isXS) {
      sessionStorage.setItem('redirect', JSON.stringify(['seriousgame', id]));
    }

    history.push('/mes-ressources');
  };

  const isDraft = game?.status === StatusItemGame.draft;

  const startGame = async () => {
    if (isDraft) {
      return;
    }

    setLoading(true);

    try {
      if (idResult) {
        history.push(`/game/play/${idResult}/0`);
        return;
      }

      if (isDisconnected) {
        const guestResult = await apiServiceNative.post('/api/create-result-game-without-user', {
          gameId: id,
        });
        history.push(`/game/play/${guestResult.idResult}/0`);
        return;
      }

      const response = await apiServiceNative.post('/api/create-result-game', { gameId: id });
      history.push(`/game/play/${response.idResult}/0`);
    } catch (error) {
      console.error('Erreur lors de édition du jeu :', error);
      setLoading(false);
    }
  };

  const restartGame = async () => {
    if (!idResult) return;

    setLoading(true);

    try {
      const response = await apiServiceNative.put(`/api/restart-game-result/${idResult}`, {});
      const newIdResult = getRestartedResultId(response);
      if (!newIdResult) {
        throw new Error('Missing idResult after restart');
      }
      history.push(`/game/play/${newIdResult}/0`);
    } catch (error) {
      console.error('Erreur lors du redémarrage du jeu :', error);
      setLoading(false);
    }
  };

  return (
    <RedesignLayout
      isaddBackground={false}
      noPadding={true}
      footer={false}
      showNav={!isDisconnected}
      isUserConnected={!isDisconnected}
      disableOverflowX={true}>
      <main className={classes.page}>
        <div className={classes.shell}>
          {!isDisconnected && (
            <div className={classes.actions}>
              <button type="button" className={classes.actionButton} onClick={goBackResource}>
                <KeyboardArrowLeftIcon className={classes.actionIcon} />
                Retour
              </button>
              {idResult && !isDraft && (
                <button type="button" className={classes.actionButton} onClick={restartGame}>
                  <ReplayIcon className={classes.actionIcon} />
                  Recommencer
                </button>
              )}
            </div>
          )}

          <div className={classes.cardWrap}>
            <section className={classes.card}>
              {loading ? (
                <div className={classes.loadingCenter}>
                  <CircularProgress />
                </div>
              ) : isDraft ? (
                <h1 className={classes.unavailableTitle}>Le jeu n&apos;est pas disponible</h1>
              ) : game ? (
                <div className={classes.cardInner}>
                  <button type="button" className={classes.primaryButton} onClick={startGame}>
                    Commencer
                  </button>
                  <div className={classes.coverBlock}>
                    <RedesignImage
                      className={classes.mediaImage}
                      src={game.couverture}
                      alt={game.title}
                    />
                  </div>
                </div>
              ) : (
                <div className={classes.loadingCenter}>
                  <CircularProgress />
                </div>
              )}
            </section>
          </div>
        </div>
      </main>
    </RedesignLayout>
  );
};

export default RedesignSeriousGameView;
